// @ts-nocheck
import React from "react";
import { useState, useEffect } from "react";
import { Link } from "react-scroll";
import { useLocation } from "react-router-dom";
import ReactGA from "react-ga4";
import { Helmet } from 'react-helmet-async';

//ヘッダー
import Header from "../../component/page_parts/header";

// フッター
import Footer from "../../component/page_parts/footer";

import Col from 'react-bootstrap/Col';
import Row from 'react-bootstrap/Row';

// モーダル
import Button from "react-bootstrap/Button";
import Modal from "react-bootstrap/Modal";

// パンくずリスト
import TableOfContents from "../../component/page_parts/common/table_of_contents";

function Welfare() {
  const [switchButtonTwoValue, setSwitchButtonOneValue] = useState<string>("1");
  const [explanationChangeValue, setSwitchButtonTwoValue] =
    useState<string>("6");

  const [activitiesType, setActivitiesType] = useState<string>("top");
  const [activitiesBtnText, setActivitiesBtnText] = useState<string>("部活動運営について");

  const baseUrl = process.env.REACT_APP_PUBLIC_URL;

  // 動画ボタン フットサル
  const videoButtonListOne = [
    {
      title: "部活動紹介動画",
      movieUrl: `${process.env.PUBLIC_URL}/jinji_mov/club_futsal_mv.mp4`,
    },
  ];

  // 動画ボタン JOG
  const videoButtonListTwo = [
    {
      title: "部活動紹介動画",
      movieUrl: `${process.env.PUBLIC_URL}/jinji_mov/club_jog_mv.mp4`,
    },
  ];

  // 動画ボタン バドミントン
  const videoButtonListThree = [
    {
      title: "部活動紹介動画",
      movieUrl: `${process.env.PUBLIC_URL}/jinji_mov/club_badminton_mv.mp4`,
    },
  ];

  // 動画ボタン ボルダリング
  const videoButtonListFour = [
    {
      title: "部活動紹介動画",
      movieUrl: `${process.env.PUBLIC_URL}/jinji_mov/club_bouldering_mv.mp4`,
    },
  ];

  //モーダル用のstate
  const [show, setShow] = useState(false);
  const [modalMovieUrl, setModalMovieUrl] = useState("");
  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  // モーダルの表示
  const showModal = (modalMovieUrl, currentId) => {
    // モーダルの中の動画のURLを変更する
    setModalMovieUrl(modalMovieUrl);
    setShow(true);
  };

  // GAID
  const gaId = process.env.REACT_APP_GA_ID;

  var element = document.getElementById("1");
  var userName = localStorage.getItem("user_name");
  ReactGA.initialize(gaId);
  ReactGA.send({
    hitType: "event",
    eventCategory: userName,
    eventAction: '福利厚生-タブ切り替え',
    eventLabel: element?.textContent,
  });

  // 上部ボタンの切り替え処理
  function dispCangeOne(event) {

    //全てのbtnToggleからis-activeを外す
    const btnToggle = document.getElementsByClassName("btnToggle");
    for (var i = btnToggle.length - 1; i >= 0; i--) {
      if (btnToggle[i].classList.contains("is-active")) {
        btnToggle[i].classList.remove("is-active");
      }
    }
    //押されたボタンにis-activeを付与
    const btnToggleId = document.getElementById(event.target.id);
    btnToggleId.classList.add("is-active");

    if (event.target.id == "1") {
      // console.log("部活動が押された");
      setSwitchButtonOneValue("1");
      setSwitchButtonTwoValue("6");
    } else if (event.target.id == "2") {
      // console.log("財産形成が押された");
      setSwitchButtonOneValue("2");
      setSwitchButtonTwoValue("1");
    } else if (event.target.id == "3") {
      // console.log("メンタルヘルスが押された");
      setSwitchButtonOneValue("3");
      setSwitchButtonTwoValue("6");
    } else if (event.target.id == "4") {
      // console.log("祝金制度が押された");
      setSwitchButtonOneValue("4");
      setSwitchButtonTwoValue("3");
    } else if (event.target.id == "5") {
      // console.log("クローズドマートが押された");
      setSwitchButtonOneValue("5");
      setSwitchButtonTwoValue("6");
    } else if (event.target.id == "6") {
      // console.log("クローズドマートが押された");
      setSwitchButtonOneValue("6");
      setSwitchButtonTwoValue("6");
    }

    // GA4タブ押下時計測
    var element = document.getElementById(event.target.id);
    var userName = localStorage.getItem("user_name");
    console.log(element?.textContent);
    ReactGA.initialize(gaId);
    ReactGA.send({
      hitType: "event",
      eventCategory: userName,
      eventAction: '福利厚生-タブ切り替え',
      eventLabel: element?.textContent,
    });
  }

  // 部活動内のコンテンツ切り替え
  function ChangeActivities(event) {
    // console.log(event.target.dataset.activitiesType);

    if (event.target.dataset.activitiesType === "top") {
      setActivitiesType("low");
      setActivitiesBtnText("部活動トップに戻る");
    } else {
      setActivitiesType("top");
      setActivitiesBtnText("部活動運営について");
    }
  }

  return (
    <>
      <Header />
      <Helmet>
        <title>Z-link 福利厚生</title>
      </Helmet>
      <div className="content-header">
        <div className="container">
          <Row>
            <Col sm={12}>
              <h1 className='page-title type-bag'>福利厚生</h1>{/* ページタイトル */}
              <p className="page-description">仕事のフォローだけじゃない、各種財産形成制度から祝金制度まで、便利な福利厚生が充実。</p>{/* ページの説明 */}
            </Col>
          </Row>
        </div>
      </div>
      <TableOfContents />

      <div className="main-wrapper jinji-related theme-jinji-welfare">
        {/* 見出し部分 */}
        <div className="contents-wrap container mt-5">
          {/* 上部ボタン郡 */}
          <div className="text-center">
            <div className="d-flex flex-wrap justify-content-between select-tags">
              <div
                className="tag flex-fill btnToggle is-active px-2"
                onClick={dispCangeOne}
                id="1"
              >
                部活動
              </div>
              <div
                className="tag flex-fill btnToggle px-2"
                onClick={dispCangeOne}
                id="6"
              >
                子育て支援
              </div>
              <div
                className="tag flex-fill btnToggle px-2"
                onClick={dispCangeOne}
                id="4"
              >
                祝金制度
              </div>
            </div>
            <div className="d-flex flex-wrap justify-content-between select-tags">
              <div
                className="tag flex-fill btnToggle px-2"
                onClick={dispCangeOne}
                id="2"
              >
                財産形成
              </div>
              <div
                className="tag flex-fill btnToggle px-2"
                onClick={dispCangeOne}
                id="5"
              >
                社員割引
              </div>
              <div
                className="tag flex-fill btnToggle px-2"
                onClick={dispCangeOne}
                id="3"
              >
                ヘルスケア
              </div>
            </div>
          </div>

          <div>
            {/* 部活動 */}
            {switchButtonTwoValue === "1" ? (
              <div className="content-activities row-12">
                <h2 className="tag-title">部活動</h2>
                <p className="lead-text">
                  部署間を超えたコミュニケーションの活性化と心と身体のリフレッシュを目的として、部活動があります。<br />
                  より多くの方に活動を楽しんでいただけるよう、部活動の入部は1人【３部活まで】となります。
                </p>
                <div className="switch-btn-wrap">
                  <button
                    type="button"
                    className="btn main-btn type-activities ms-auto"
                    onClick={ChangeActivities}
                    data-activities-type={activitiesType}
                  >
                    {activitiesBtnText}
                  </button>
                </div>
                <div className={"contents-body" + (activitiesType === "top" ? " is-active" : "")}>
                  <div className="schedule-box">
                    <h3 className="icon-title type-pencil mt-small">直近の活動予定</h3>
                    {/* <div className="body">
                      <img
                        src={process.env.PUBLIC_URL + '/jinji_pic/schedule.png'}
                        alt="直近の活動予定"
                        width={1053}
                        height={200}
                        loading="lazy"
                      />
                    </div> */}
<div
  className="body"
  style={{
    overflow: "hidden",
    width: "100%",
  }}
>
  <iframe
    src="https://docs.google.com/presentation/d/1Jqta6icX-Epc0XPodeG-EnCevBonNybbrqZLp0sK-nQ/embed?start=false&loop=false&delayms=3000&rm=minimal"
    title="直近の活動予定"
    loading="lazy"
    style={{
      display: "block",
      width: "calc(100% + 4px)",
      aspectRatio: "10 / 2.6",
      marginLeft: "-2px",
      marginTop: "-2px",
      marginRight: "-2px",
      marginBottom: "-2px",
      border: 0,
    }}
  />
</div>
                  </div>
                  <Row className="menu-btn-wrap first">
                    <Col sm={3}>
                      <Link
                        to="basketball"
                        smooth={true}
                        duration={500}
                        offset={-100}
                        className="btn main-btn type-internal"
                      >
                        バスケ部
                      </Link>
                    </Col>
                    <Col sm={3}>
                      <Link
                        to="futsal"
                        smooth={true}
                        duration={500}
                        offset={-100}
                        className="btn main-btn type-internal"
                      >
                        フットサル部
                      </Link>
                    </Col>
                    <Col sm={3}>
                      <Link
                        to="jog"
                        smooth={true}
                        duration={500}
                        offset={-100}
                        className="btn main-btn type-internal"
                      >
                        JOG部
                      </Link>
                    </Col>
                    <Col sm={3}>
                      <Link
                        to="badminton"
                        smooth={true}
                        duration={500}
                        offset={-100}
                        className="btn main-btn type-internal"
                      >
                        バドミントン部
                      </Link>
                    </Col>
                  </Row>
                  <Row className="menu-btn-wrap second">
                    <Col sm={3}>
                      <Link
                        to="bouldering"
                        smooth={true}
                        duration={500}
                        offset={-100}
                        className="btn main-btn type-internal"
                      >
                        ボルダリング部
                      </Link>
                    </Col>
                  </Row>
                  <div className="activities-box-wrap">
                    <div className="activities-box type-basketball" id="basketball">
                      <h3 className="icon-title type-pencil mt-0">バスケ部</h3>
                      <div className="body">
                        <div className="img-wrap text-center">
                          <img
                            src={process.env.PUBLIC_URL + '/jinji_pic/basketball.png'}
                            alt="バスケ部概要"
                            width={2000}
                            height={1414}
                            loading="lazy"
                          />
                        </div>
                        <div className="activity-record">
                          <h4 className="bg-title">活動記録</h4>
                          <ul>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=1937"><span className="record-date">2024年4月2日</span>【🏀バスケ部】2024年バスケ部始動です！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=1285"><span className="record-date">2023年10月17日</span>【🏀バスケ部】年内最後のEnjoyバスケ！</a></li>
                          </ul>
                        </div>
                        <div className="joining text-center">
                          <p>バスケ部へ参加希望の方は、こちらのフォームより送信ください。<br />後日、部から個別にご連絡します。</p>
                          <Row className="btn-wrap justify-content-center">
                            <Col sm={6}>
                              <a href="https://docs.google.com/forms/d/e/1FAIpQLSd7pUK3dxmlgAktTMR76dDl60ruiRwz-PG1DE4U5gS8gRnmEg/viewform" target="_blank" className="btn main-btn type-external">
                                バスケ部に参加する！
                              </a>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                    <div className="activities-box type-futsal" id="futsal">
                      <h3 className="icon-title type-pencil mt-0">フットサル部</h3>
                      <div className="body">
                        <div className="img-wrap text-center">
                          <img
                            src={process.env.PUBLIC_URL + '/jinji_pic/futsal.png'}
                            alt="フットサル部概要"
                            width={2000}
                            height={1414}
                            loading="lazy"
                          />
                        </div>
                        <Row className="btn-wrap justify-content-center">
                          <Col sm={6}>
                            {videoButtonListOne.map((movie, index) => (
                              <Button
                                id={"movie-btn-" + (index + 1)}
                                className='btn main-btn type-movie btn btn-primary'
                                key={index}
                                variant="primary"
                                onClick={(e) => showModal(movie.movieUrl, e.currentTarget.id)}
                                dangerouslySetInnerHTML={{
                                  __html: movie.title,
                                }}
                              >
                              </Button>
                            ))}
                            <Modal
                              show={show}
                              onHide={handleClose}
                              className="modal-lg evaluation-modal"
                              size="lg"
                              centered
                            >
                              <Modal.Header closeButton></Modal.Header>
                              <Modal.Body>
                                <video
                                  className="evaluation-modal__video"
                                  preload="none"
                                  autoPlay
                                  controls
                                  loop
                                  muted
                                  playsInline
                                  poster="#"
                                >
                                  <source src={modalMovieUrl} type="video/mp4" />
                                </video>
                              </Modal.Body>
                            </Modal>
                          </Col>
                        </Row>
                        <div className="activity-record">
                          <h4 className="bg-title">活動記録</h4>
                          <ul>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5188"><span className="record-date">2026年3月29日</span>【⚽フットサル部】味の素スタジアム(隣接コート)で交流試合をしてきました！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3701"><span className="record-date">2025年4月26日</span>【⚽フットサル部】代々木リベンジマッチ！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3567"><span className="record-date">2025年3月27日</span>【⚽フットサル部】他社との交流フットサル開催！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3423"><span className="record-date">2025年2月9日</span>【⚽フットサル部】大会参加！（としっかり打ち上げ）</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2864"><span className="record-date">2024年10月26日</span>【⚽フットサル部】男女MIXの大会に初参戦！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2527"><span className="record-date">2024年8月31日</span>【⚽フットサル部】午前中からフットサル！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2130"><span className="record-date">2024年5月10日</span>【⚽フットサル部】わちゃ蹴りフットサル会！！@新宿</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=1820"><span className="record-date">2024年2月17日</span>【⚽フットサル部】わちゃ蹴りフットサル会！！＠新宿</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=1368"><span className="record-date">2023年11月26日</span>【⚽フットサル部】わちゃ蹴りフットサル会！！＠新宿</a></li>
                          </ul>
                        </div>
                        <div className="joining text-center">
                          <p>フットサル部へ参加希望の方は、こちらのフォームより送信ください。<br />後日、部から個別にご連絡します。</p>
                          <Row className="btn-wrap justify-content-center">
                            <Col sm={6}>
                              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfCSnOSQ9mavVbMmWL_LDii6vH4yQ5HDXBj1nhyhJBgPvskeA/viewform" target="_blank" className="btn main-btn type-external">
                                フットサル部に参加する！
                              </a>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                    <div className="activities-box type-jog" id="jog">
                      <h3 className="icon-title type-pencil mt-0">JOG部</h3>
                      <div className="body">
                        <div className="img-wrap text-center">
                          <img
                            src={process.env.PUBLIC_URL + '/jinji_pic/jog.png'}
                            alt="JOG部概要"
                            width={2000}
                            height={1414}
                            loading="lazy"
                          />
                        </div>
                        <Row className="btn-wrap justify-content-center">
                          <Col sm={6}>
                            {videoButtonListTwo.map((movie, index) => (
                              <Button
                                id={"movie-btn-" + (index + 1)}
                                className='btn main-btn type-movie btn btn-primary'
                                key={index}
                                variant="primary"
                                onClick={(e) => showModal(movie.movieUrl, e.currentTarget.id)}
                                dangerouslySetInnerHTML={{
                                  __html: movie.title,
                                }}
                              >
                              </Button>
                            ))}
                            <Modal
                              show={show}
                              onHide={handleClose}
                              className="modal-lg evaluation-modal"
                              size="lg"
                              centered
                            >
                              <Modal.Header closeButton></Modal.Header>
                              <Modal.Body>
                                <video
                                  className="evaluation-modal__video"
                                  preload="none"
                                  autoPlay
                                  controls
                                  loop
                                  muted
                                  playsInline
                                  poster="#"
                                >
                                  <source src={modalMovieUrl} type="video/mp4" />
                                </video>
                              </Modal.Body>
                            </Modal>
                          </Col>
                        </Row>
                        <div className="activity-record">
                          <h4 className="bg-title">活動記録</h4>
                          <ul>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5662"><span className="record-date">2026年8月16日</span>【🏃‍♂️JOG部】夏休み最終日は、日本で最も多くの人が登るあの山へ</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5296"><span className="record-date">2026年5月17日</span>【🏃‍♂️JOG部】トレランレースに参加してきました！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5270"><span className="record-date">2026年4月23日</span>【🏃‍♂️JOG部】今週のJOG部はマラソンシーズンです！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5173"><span className="record-date">2026年3月29日</span>【🏃‍♂️JOG部】シーズン到来！奥武蔵の春を駆けてきました🌸</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5092"><span className="record-date">2026年3月15日</span>【🏃‍♂️JOG部】初マラソンチャレンジ！実況解説！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4902"><span className="record-date">2026年1月18日</span>【🏃‍♂️JOG部】1/18開催：Zenken JOG部・フロストバイトロードレース参戦レポート！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4704"><span className="record-date">2025年11月30日</span>【🏃‍♂️JOG部】11/30開催：皇居ランレポート♪</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4701"><span className="record-date">2025年11月27日</span>【🏃‍♂️JOG部】意外と楽しい「しごおわラン」って？</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4511"><span className="record-date">2025年10月19日</span>【🏃‍♂️JOG部】東京レガシーハーフマラソン2025に参加してきました！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4473"><span className="record-date">2025年10月8日</span>【🏃‍♂️JOG部】ランナーの聖地✨皇居はシーズンモード！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4416"><span className="record-date">2025年9月20日</span>【🏃‍♂️JOG部】富士の樹海を駆け抜けろ！富士山麓トレイルランに参戦</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4203"><span className="record-date">2025年8月17日</span>【🏃‍♂️JOG部】トレイルランニング練習会開催</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4137"><span className="record-date">2025年7月27日</span>【🏃‍♂️JOG部】定番イベント「皇居ラン」開催</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4132"><span className="record-date">2025年7月21日</span>【🏃‍♂️JOG部】灼熱の湘南の海を山を駆け抜ける</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3773"><span className="record-date">2025年5月17日</span>【🏃‍♂️JOG部】トレラン大会レポート！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3704"><span className="record-date">2025年5月4日</span>【🏃‍♂️JOG部】GWのトレラン練習</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3641"><span className="record-date">2025年4月6日</span>【🏃‍♂️JOG部】トレラン大会&パン食い競争</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3492"><span className="record-date">2025年2月23日</span>【🏃‍♂️JOG部】トレイルランニング練習1回目！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3400"><span className="record-date">2025年2月9日</span>【🏃‍♂️JOG部】ランナーで大賑わいの皇居ラン！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3359"><span className="record-date">2025年1月19日</span>【🏃‍♂️JOG部】フロストバイトロードレース参戦！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3154"><span className="record-date">2024年12月1日</span>【🏃‍♂️JOG部】皇居一般公開＆社長の麻布ランチリスト店へ！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2963"><span className="record-date">2024年11月10日</span>【🏃‍♂️JOG部】自己新記録を更新！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2706"><span className="record-date">2024年10月9日</span>【🏃‍♂️JOG部】いよいよマラソンシーズンに突入！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2662"><span className="record-date">2024年9月29日</span>【🏃‍♂️JOG部】気持ちいい季節になりました！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2348"><span className="record-date">2024年7月21日</span>【🏃‍♂️JOG部】汗をかくのって気持ちがいい！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=1910"><span className="record-date">2024年1~4月</span>【🏃‍♂️JOG部】待ちに待ったマラソンシーズン！！大会レポート</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=1284"><span className="record-date">2023年10月22日</span>【🏃‍♂️JOG部】今年も参戦！国立競技場リレーマラソン！</a></li>
                          </ul>
                        </div>
                        <div className="joining text-center">
                          <p>JOG部へ参加希望の方は、こちらのフォームより送信ください。<br />後日、部から個別にご連絡します。</p>
                          <Row className="btn-wrap justify-content-center">
                            <Col sm={6}>
                              <a href="https://docs.google.com/forms/d/e/1FAIpQLSfZLeq8042wASqyYEm2iXwJVW-eHIIlq7NtQaK6DDVUkwJRIg/viewform" target="_blank" className="btn main-btn type-external">
                                JOG部に参加する！
                              </a>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                    <div className="activities-box type-badminton" id="badminton">
                      <h3 className="icon-title type-pencil mt-0">バドミントン部</h3>
                      <div className="body">
                        <div className="img-wrap text-center">
                          <img
                            src={process.env.PUBLIC_URL + '/jinji_pic/badminton.png'}
                            alt="バドミントン部概要"
                            width={2000}
                            height={1414}
                            loading="lazy"
                          />
                        </div>
                        <Row className="btn-wrap justify-content-center">
                          <Col sm={6}>
                            {videoButtonListThree.map((movie, index) => (
                              <Button
                                id={"movie-btn-" + (index + 1)}
                                className='btn main-btn type-movie btn btn-primary'
                                key={index}
                                variant="primary"
                                onClick={(e) => showModal(movie.movieUrl, e.currentTarget.id)}
                                dangerouslySetInnerHTML={{
                                  __html: movie.title,
                                }}
                              >
                              </Button>
                            ))}
                            <Modal
                              show={show}
                              onHide={handleClose}
                              className="modal-lg evaluation-modal"
                              size="lg"
                              centered
                            >
                              <Modal.Header closeButton></Modal.Header>
                              <Modal.Body>
                                <video
                                  className="evaluation-modal__video"
                                  preload="none"
                                  autoPlay
                                  controls
                                  loop
                                  muted
                                  playsInline
                                  poster="#"
                                >
                                  <source src={modalMovieUrl} type="video/mp4" />
                                </video>
                              </Modal.Body>
                            </Modal>
                          </Col>
                        </Row>
                        <div className="activity-record">
                          <h4 className="bg-title">活動記録</h4>
                          <ul>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3666"><span className="record-date">2025年4月12日</span>【🏸バドミントン部】念願の移転後・初開催✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2871"><span className="record-date">2024年10月25日</span>【🏸バドミントン部】少人数でも大満足！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2373"><span className="record-date">2024年7月23日</span>【🏸バドミントン部】初心者の方でも楽しめます！！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=1960"><span className="record-date">2024年3~4月</span>【🏸バドミントン部】積極開催中です！！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=1283"><span className="record-date">2023年9月6日</span>【🏸バドミントン部】シャッフル試合に、白熱！！</a></li>
                          </ul>
                        </div>
                        <div className="joining text-center">
                          <p>バドミントン部へ参加希望の方は、こちらのフォームより送信ください。<br />後日、部から個別にご連絡します。</p>
                          <Row className="btn-wrap justify-content-center">
                            <Col sm={6}>
                              <a href="https://docs.google.com/forms/d/e/1FAIpQLScptMUgckCcnajGE6A_mnZGn8pagILeJX8H2KlJWWZto8oSGQ/viewform" target="_blank" className="btn main-btn type-external">
                                バドミントン部に参加する！
                              </a>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                    <div className="activities-box type-bouldering" id="bouldering">
                      <h3 className="icon-title type-pencil mt-0">ボルダリング部</h3>
                      <div className="body">
                        <div className="img-wrap text-center">
                          <img
                            src={process.env.PUBLIC_URL + '/jinji_pic/bouldering.png'}
                            alt="ボルダリング部概要"
                            width={2000}
                            height={1414}
                            loading="lazy"
                          />
                        </div>
                        <Row className="btn-wrap justify-content-center">
                          <Col sm={6}>
                            {videoButtonListFour.map((movie, index) => (
                              <Button
                                id={"movie-btn-" + (index + 1)}
                                className='btn main-btn type-movie btn btn-primary'
                                key={index}
                                variant="primary"
                                onClick={(e) => showModal(movie.movieUrl, e.currentTarget.id)}
                                dangerouslySetInnerHTML={{
                                  __html: movie.title,
                                }}
                              >
                              </Button>
                            ))}
                            <Modal
                              show={show}
                              onHide={handleClose}
                              className="modal-lg evaluation-modal"
                              size="lg"
                              centered
                            >
                              <Modal.Header closeButton></Modal.Header>
                              <Modal.Body>
                                <video
                                  className="evaluation-modal__video"
                                  preload="none"
                                  autoPlay
                                  controls
                                  loop
                                  muted
                                  playsInline
                                  poster="#"
                                >
                                  <source src={modalMovieUrl} type="video/mp4" />
                                </video>
                              </Modal.Body>
                            </Modal>
                          </Col>
                        </Row>
                        <div className="activity-record">
                          <h4 className="bg-title">活動記録</h4>
                          <ul>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5642"><span className="record-date">2026年8月21日</span>【⛰️ボルダリング部】まさかのジムの休業！でも登った</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5561"><span className="record-date">2026年7月24日</span>【⛰️ボルダリング部】1年ぶりのBASECAMP新橋店！マイシューズ忘却の悲劇と、奇跡の雨上がりの韓国夜市！🍺✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5520"><span className="record-date">2026年7月10日</span>【⛰️ボルダリング部】「疲れたー！」の連呼から始まる奇跡？限界を超えた頭脳派クライミングと、マニアックすぎる夜！🧗‍♂️✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5419"><span className="record-date">2026年6月20日</span>【⛰️ボルダリング部】命綱を握るゼホを信じてくれw！屈強BODY💪の浅井リーダー参戦のボルボル探検隊🧗‍♂️✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5387"><span className="record-date">2026年6月5日</span>【⛰️ボルダリング部】限界突破の華金！全員ボロボロ、でも笑顔は120%！？🧗‍♂️✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5318"><span className="record-date">2026年5月19日</span>【⛰️ボルダリング部】重力を忘れる快感！新メンバー内田さん参戦で「登り欲」が止まらない夜！🧗‍♂️✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5247"><span className="record-date">2026年4月18日</span>【⛰️ボルダリング部】空高く限界の先へ！初めてのトップロープでアドレナリン大爆発！！🧗‍♂️✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5153"><span className="record-date">2026年3月27日</span>【⛰️ボルダリング部】Zenkenルート開拓！？おでんとビールで心機一転、3月の壁も暑かった！🧗‍♂️✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5087"><span className="record-date">2026年3月17日</span>【⛰️ボルダリング部】仲間を救え！ボルダレンジャー！！🦸🏼</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5063"><span className="record-date">2026年3月6日</span>【⛰️ボルダリング部】リードクライミングに挑戦！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=5016"><span className="record-date">2026年2月20日</span>【⛰️ボルダリング部】限界の向こう側へ！傾斜愛とチルガイ、そしてバイアスロンの熱い夜🧗‍♂️✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4984"><span className="record-date">2026年2月13日</span>【⛰️ボルダリング部】平日夜の熱気！復活劇と急成長、そして幻のロープ…！？🧗‍♂️✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4943"><span className="record-date">2026年1月23日</span>【⛰️ボルダリング部】ボルダリング部なのにSIからきた刺客のブレイクダンスでワクワク！💥🧗‍♂️✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4896"><span className="record-date">2026年1月16日</span>【⛰️ボルダリング部】2026年華麗なるスタート！貸切チャンスで熱血マンツーマンサポート！？🧗‍♀️✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4799"><span className="record-date">2025年12月12日</span>【⛰️ボルダリング部】2025年登り納め！天才現る！？＆AIの奇跡で全員集合の巻🧗‍♂️✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4682"><span className="record-date">2025年11月21日</span>【⛰ボルダリング部】涙の初クリア！？成長と情熱が爆発した熱狂の夜！🧗‍♂️＆餃子が辛い！🥟🔥</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4656"><span className="record-date">2025年11月15日</span>【⛰ボルダリング部】コアメンバー集結！シミュレーションの鬼と「もう無理！」の絶叫響く夜🧗‍♂️😂</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4555"><span className="record-date">2025年10月24日</span>【⛰ボルダリング部】10月の熱気！秋の壁でワイワイセッション＆乾杯ナイト！🧗‍♂️✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4469"><span className="record-date">2025年10月3日</span>【⛰ボルダリング部】華麗なる新星🩰と、ジムマスターを動かした”悪だくみ”おじさんズ！？</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4394"><span className="record-date">2025年9月19日</span>【⛰ボルダリング部】壁に挑む情熱！成長の秋、達成感120%の夜！🧗‍♂️✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4326"><span className="record-date">2025年9月5日</span>【⛰ボルダリング部】ドタサン全開！8人で登りきった夜🔥</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4265"><span className="record-date">2025年8月21日</span>【⛰ボルダリング部】8月2回目の開催は、SPIDER@麻布十番！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4150"><span className="record-date">2025年8月1日</span>【⛰ボルダリング部】8月も登ってきましたー！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4094"><span className="record-date">2025年7月19日</span>【⛰ボルダリング部】アキバ遠征！土曜開催で大型ジムデビュー✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=4010"><span className="record-date">2025年6月20日</span>【⛰ボルダリング部】登ってつながる仲間たち✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3965"><span className="record-date">2025年6月6日</span> 【⛰ボルダリング部】「Boruda High」発症！？</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3794"><span className="record-date">2025年5月23日</span>【⛰ボルダリング部】初のジム貸し切り開催！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3723"><span className="record-date">2025年5月9日</span>【⛰ボルダリング部】連休明けもさっそく登ります！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3683"><span className="record-date">2025年4月18日</span>【⛰ボルダリング部】じっくり取り組む！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3651"><span className="record-date">2025年4月11日</span>【⛰ボルダリング部】登り放題の新ジムをご紹介！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3625"><span className="record-date">2025年4月7日</span>【⛰ボルダリング部】登りすぎ注意報🌸</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3523"><span className="record-date">2025年3月14日</span>【⛰ボルダリング部】体験入部も大歓迎です🌼</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3490"><span className="record-date">2025年2月21日</span>【⛰ボルダリング部】楽しみ方は人それぞれ♪</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3404"><span className="record-date">2025年2月6日</span>【⛰ボルダリング部】初の平日開催！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3382"><span className="record-date">2025年1月14日</span>【⛰ボルダリング部】2025年初クライムしてきました💪</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=3148"><span className="record-date">2024年12月5日</span>【⛰ボルダリング部】次の日は優しいグーしか出せませんが楽しいです！</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2948"><span className="record-date">2024年11月8日</span>【⛰ボルダリング部】マイペースを楽しむ至福の時間✨</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2861"><span className="record-date">2024年10月25日</span>【⛰ボルダリング部】スポーツが苦手な人にもおすすめです💃</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2686"><span className="record-date">2024年9月27日</span>ボルダリング部】世界一うまいビールの秘密</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2577"><span className="record-date">2024年9月13日</span>【ボルダリング部】週末の夜は頭をリフレッシュ！仕事のモヤモヤを解消💛</a></li>
                            <li><a href="https://www.ztree.cfbx.jp/info_lists/deteil?id=2352"><span className="record-date">2024年7月5・19日</span>【ボルダリング部】順調に成長しています！</a></li>
                          </ul>
                        </div>
                        <div className="joining text-center">
                          <p>ボルダリング部へ参加希望の方は、こちらのフォームより送信ください。<br />後日、部から個別にご連絡します。</p>
                          <Row className="btn-wrap justify-content-center">
                            <Col sm={6}>
                              <a href="https://docs.google.com/forms/d/e/1FAIpQLSdyYqNbZ3Zrz3n_VZi9YGLhcCDwtDP1PjgkJyPFvYkDeuhodw/viewform" target="_blank" className="btn main-btn type-external">
                                ボルダリング部に参加する！
                              </a>
                            </Col>
                          </Row>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div className={"contents-body" + (activitiesType !== "top" ? " is-active" : "")}>
                  <div className="operation-box-wrap">
                    <h3 className="icon-title type-pencil mt-0">部活動の運営について</h3>
                    <div className="body">
                      <div className="operation-box">
                        <h4 className="bg-title">部活動設立の要件</h4>
                        <ol>
                          <li>部活動の所属メンバーは15名以上で構成されていること</li>
                          <li>部活動運営に必要な、責任者及び副責任者、会計担当を選任していること</li>
                          <li>営利を目的としたものや、政治活動、宗教活動に関わるものでないこと</li>
                          <li>活動内容が重複する部活でないこと</li>
                        </ol>
                      </div>
                      <div className="operation-box">
                        <h4 className="bg-title">対象者</h4>
                        <p>対象者は雇用形態に関わらず全従業員を対象とするが、原則として1人3部活までの参加とする</p>
                      </div>
                      <div className="operation-box">
                        <h4 className="bg-title">補助金の申請</h4>
                        <p>補助金は、設備等（場所代・レンタル代）の代金及び活動に伴う懇親会の飲食料金に限り<br />月額70,000円を上限として実費を支給する<br />※3ヵ月以上に渡り活動がない部活は支給対象外とします</p>
                      </div>
                      <div className="operation-box">
                        <h4 className="bg-title">活動時の留意点</h4>
                        <ol>
                          <li>活動は所定時間外に実施すること</li>
                          <li>活動実績の有無に関わらず、毎月月末までに活動報告書にて報告すること</li>
                          <li>活動スケジュールを所定のGoogleカレンダーに記入すること</li>
                          <li>活動状況を社内に広く周知するため、活動記録を定期的にブログに掲載すること</li>
                        </ol>
                      </div>
                      <div className="operation-box">
                        <h4 className="bg-title">各書類</h4>
                        <p><a href="https://sites.google.com/zenken.co.jp/contracts-regulations/regulations/regulations_related_to_general_affairs/-for-the-operation-of-club-activities?authuser=0" target="_blank" rel="noopener noreferrer" className='text-link type-external'>契約書・規程BOX</a>よりアクセスの上、ご確認ください</p>
                      </div>
                      <div className="operation-box">
                        <h4 className="bg-title">申請方法について</h4>
                        <p>申請方法：<a href="https://rsdesign.rakurakuseisan.jp/_5ZwGywYVPa/" target="_blank" rel="noopener noreferrer" className='text-link type-external'>楽楽精算</a>のワークフロー「部活動申請書」から申請してください。</p>
                        <div className="img-wrap">
                          <img
                            src={process.env.PUBLIC_URL + '/jinji_pic/rakuraku.jpg'}
                            alt="楽楽精算の画面キャプチャ"
                            width={604}
                            height={455}
                            loading="lazy"
                          />
                        </div>
                        <p>部活動の運営に関するお問い合わせは、人材戦略統括本部　人事部　人材戦略チーム　までお願いします。</p>
                        <p>担当者の内線番号/携帯番号の確認は、<a href={process.env.REACT_APP_PUBLIC_URL + "/employee_list?defaultOption=203"}>従業員名簿</a>よりご確認ください。</p>
                        <p className="mt-4 pt-3">なお、本規則は令和5年7月1日から施行とします。</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ) : (
              <></>
            )}

            {/* 財産形成(デフォルト) */}
            {switchButtonTwoValue === "2" ? (
              <div className="contentOne row-12">
                <h2 className="tag-title">財産形成</h2>
                <p>
                  2つの財産形成制度。どちらも給与から自動拠出されるので、手間なく積み立てが可能。<br />
                  資産形成にぜひお役立てください。選択制DCは3月と9月、従業員持ち株会は2月と8月に案内をいたします。
                </p>
                <Row className='my-4'>
                  <Col sm={6}>
                    <Link
                      to="dc"
                      smooth={true}
                      duration={500}
                      offset={-100}
                      className="btn main-btn type-internal"
                    >
                      選択制DC（企業型確定拠出年⾦）
                    </Link>
                  </Col>
                  <Col sm={6}>
                    <Link
                      to="stock"
                      smooth={true}
                      duration={500}
                      offset={-100}
                      className="btn main-btn type-internal"
                    >
                      従業員持株会
                    </Link>
                  </Col>
                </Row>
              </div>
            ) : (
              <></>
            )}

            {/* ヘルスケア */}
            {switchButtonTwoValue === "3" ? (
              <div className="contentTwo">
                <h2 className="tag-title">ヘルスケア</h2>
                <p>詳細は「<a href={baseUrl + '/lifestyle'} class="text-link">人事ガイド＞ヘルスケア</a>」をご覧ください。</p>
              </div>
            ) : (
              <></>
            )}

            {/* 祝金制度 */}
            {switchButtonTwoValue === "4" ? (
              <div className="contentThree">
                <h2 className="tag-title">祝金制度</h2>
                <p>
                  皆さんにとってうれしい制度をピックアップ。福利厚生はお得でなくっちゃ意味がない！{" "}
                </p>
                <Row className='mb-4'>
                  <Col sm={6}>
                    <Link
                      to="marriage"
                      smooth={true}
                      duration={500}
                      offset={-100}
                      className="btn main-btn type-internal"
                    >
                      結婚・出産祝金
                    </Link>
                  </Col>
                  <Col sm={6}>
                    <Link
                      to="paid"
                      smooth={true}
                      duration={500}
                      offset={-100}
                      className="btn main-btn type-internal"
                    >
                      リファラル（社員紹介）制度
                    </Link>
                  </Col>
                </Row>
              </div>
            ) : (
              <></>
            )}

            {/* 社員割引 */}
            {switchButtonTwoValue === "5" ? (
              <div className="contentFour">
                <h2 className="tag-title">社員割引</h2>
                <p>
                  Zenken社員向けの各種特典をご用意いただきました。スーツの割引をはじめとした、日常に役立つお得なサービスが多数ございます。<br />お得なこの機会をぜひご活用ください！　※お問い合わせ先は「クローズドマート」「ルームピア」は総務へ。「インターネット・アカデミー」「SBC Wellness」は人事へ。それ以外は大学サポートへお願いします。
                </p>
                <div className="service-list-area">
                  <a className="service-item clumOne" href="https://www.closedmart-members.com/corporate_login.php?transactionid=8dd3f62ff69c6ac33c56c1d0c46a802e2f7294c9" target="_blank" rel="noopener noreferrer">
                    <div className="service-item-left">
                      <div className="service-item-catch"><p>訳あり品が最大80％OFF</p></div>
                      <div className="service-item-img for-closedmart"><img className="for-closedmart" src="/jinji_pic/closed_mart.png" alt="クローズマートのロゴ" /></div>
                      <div className="service-item-title"><p>クローズマート（食品・日用品 等）</p></div>
                    </div>
                    <div className="service-item-right">
                      <h3>【CLOSED Mart】とは？</h3>
                      <div class="d-flex flex-wrap-area">
                        <div class="no-link-btn">廃棄ロスの削減</div>
                        <div class="no-link-btn">途上国支援に貢献</div>
                      </div>
                      <p>賞味期限が近づいた食品や、仕様変更や型落ちになった日用品、余剰在庫による処分品など、さまざまな理由により販売することが困難な商品を格安で購入でき、SDGsにも貢献できるのが、社会貢献型職域販売サイト「CLOSED Mart」。Zenkenは食品・日用品等を購入することで廃棄ロス削減や途上国支援に取り組んでいきます。</p>
                      <p className="coupon-code">法人コード<span>「9032G8767」</span>を入力しログインしてください。</p>
                    </div>
                  </a>
                </div>
                <div className="service-list-area">
                  <a className="service-item clumOne" href="https://www.internetacademy.co.jp/clients/z_wun79z59zr.html" target="_blank" rel="noopener noreferrer">
                    <div className="service-item-left">
                      <div className="service-item-catch"><p>受講料が最大40%OFF</p></div>
                      <div className="service-item-img for-closedmart"><img className="for-closedmart" src="/jinji_pic/ft_logo_ia.png" alt="インターネット・アカデミーのロゴ" /></div>
                      <div className="service-item-title"><p>インターネットアカデミー<br />(スキルアップ・研修)</p></div>
                    </div>
                    <div className="service-item-right">
                      <p className="coupon-code">インターネット・アカデミーの各講座を、弊社限定の特別価格(最大40%OFF)で受講可能。
                      まずは、講座一覧・弊社限定料金ページをチェック!!</p>
                      <p className="coupon-code">＜お申込み方法＞<br />お名前、会社名、お申込みご希望の講座名、クーポンコード<span>「B4LW5E2N」</span>を記入してお問い合わせフォームからお問い合わせください。<br />入力いただいたメールアドレス宛に担当者からご契約案内が届きます。<br />また、人事への報告は不要となります。</p>
                    </div>
                  </a>
                </div>
                <div className="service-list-area">
                <a className="service-item" href="https://drive.google.com/file/d/1fehbwcTYQRkALBSbMwQBhsDvojHI8CLx/view" target="_blank" rel="noopener noreferrer">
                    <div className="service-item-catch"><p>対象医療 １０％ＯＦＦ</p></div>
                    <div className="service-item-img"><img src="/jinji_pic/sbc wellness.png" alt="SBC WELLNESSのロゴ" /></div>
                    <div className="service-item-title"><p>SBC Wellness（美容医療・審美歯科・卵子凍結）</p></div>
                    <div className="service-item-detail"><p>受診時は注意事項を確認の上、予約必須です。<br />※予約時に法人コード<span>「A074」</span>を伝えてください。</p></div>
                  </a>
                  <a className="service-item" href="https://drive.google.com/file/d/1Eokfx-L5R7qc0JNXSWobWIGZAYOHUjUi/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                    <div className="service-item-catch twoRow"><p>賃貸：仲介手数料６０% OFF<br />売買：２０万円割引</p></div>
                    <div className="service-item-img"><img src="/jinji_pic/room_peer.png" alt="ルームピアのロゴ" /></div>
                    <div className="service-item-title"><p>ルームピア（不動産）</p></div>
                    <div className="service-item-detail"><p>来店前に「提携企業専用窓口」に連絡してください。</p></div>
                  </a>
                  <a className="service-item" href="https://drive.google.com/file/d/1tIXIdT4upxhykzYJnAy6INs6jjtjlQdN/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                    <div className="service-item-catch"><p>仲介手数料最大２０％ＯＦＦ</p></div>
                    <div className="service-item-img"><img src="/jinji_pic/minimini.png" alt="ミニミニのロゴ" /></div>
                    <div className="service-item-title"><p>ミニミニ（不動産）</p></div>
                    <div className="service-item-detail"><p>来店前にチラシ下部に記載されている担当者へ事前連絡してください。</p></div>
                  </a>
                </div>
                <div className="service-list-area">
                <a className="service-item" href="https://drive.google.com/file/d/1f9Aag84JKgDY1exGVsMPWYmdNpPC0yLK/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                    <div className="service-item-catch"><p>２％ポイントアップ</p></div>
                    <div className="service-item-img for-biccamera"><img className="for-biccamera" src="/jinji_pic/bic_camera.png" alt="ビックカメラのロゴ" /></div>
                    <div className="service-item-title"><p className="for-biccamera">ビックカメラ（家電）</p></div>
                    <div className="service-item-detail"><p>・チラシを事前に印刷し、店舗に持参。<br />・ビックカメラ.comでは会計画面で<span>「D097127」</span>クーポンコードを入力。</p></div>
                  </a>
                  <a className="service-item" href="https://drive.google.com/file/d/1pZ53yUhhMa_dD21mx8NvhWBaqf3yP_AE/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                    <div className="service-item-catch"><p>割引券＋さらに１０％ＯＦＦ</p></div>
                    <div className="service-item-img for-aoki"><img className="for-aoki" src="/jinji_pic/aoki.jpg" alt="アオキのロゴ" /></div>
                    <div className="service-item-title"><p>アオキ（スーツ類）</p></div>
                    <div className="service-item-detail"><p>チラシを事前に印刷し、店舗に持参</p></div>
                  </a>
                  <a className="service-item" href="https://drive.google.com/file/d/1hmdrVkcFzQ81nT0b-Im11Q2p77iAZMOT/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                    <div className="service-item-catch"><p>値下げ前価格より２０％ＯＦＦ</p></div>
                    <div className="service-item-img for-haruyama"><img className="for-haruyama" src="/jinji_pic/haruyama.jpg" alt="はるやまのロゴ" /></div>
                    <div className="service-item-title"><p>はるやま（スーツ類）</p></div>
                    <div className="service-item-detail"><p>チラシを事前に印刷し、店舗に持参</p></div>
                  </a>
                </div>
                <div className="service-list-area">
                <a className="service-item" href="https://drive.google.com/file/d/1Y77DeulSszUiO5JE0JfEV_wbuRp1ZI2-/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                    <div className="service-item-catch"><p>割引券＋さらに１０％ＯＦＦ</p></div>
                    <div className="service-item-img"><img src="/jinji_pic/konaka.png" alt="コナカのロゴ" /></div>
                    <div className="service-item-title"><p>コナカ（スーツ類）</p></div>
                    <div className="service-item-detail"><p>チラシを事前に印刷し、店舗に持参</p></div>
                  </a>
                  <a className="service-item" href="https://drive.google.com/file/d/12ewexURfisqFOWFksFN4aaHsmrNUOO_j/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                    <div className="service-item-catch"><p>１５％ＯＦＦ</p></div>
                    <div className="service-item-img for-megane"><img className="for-megane" src="/jinji_pic/meganesupa.png" alt="メガネスーパーのロゴ" /></div>
                    <div className="service-item-title"><p>メガネスーパー（メガネ・コンタクト）</p></div>
                    <div className="service-item-detail"><p>チラシを事前に印刷し、店舗に持参</p></div>
                  </a>
                  <a className="service-item" href="https://drive.google.com/file/d/1UNK18MqfSYwBhjxjINmPMLU9uAWlpxCb/view?usp=sharing" target="_blank" rel="noopener noreferrer">
                    <div className="service-item-catch"><p>購入金額別の割引特典</p></div>
                    <div className="service-item-img for-daiwa"><img className="for-daiwa" src="/jinji_pic/daiwa_cycle.png" alt="ダイワサイクル（自転車）概要" /></div>
                    <div className="service-item-title"><p>ダイワサイクル（自転車）</p></div>
                    <div className="service-item-detail"><p>チラシを事前に印刷し、店舗に持参</p></div>
                  </a>
                </div>
                <div className="service-list-area">
                  <a className="service-item" href="https://www.netoff.co.jp/campaign/zenken.jsp" target="_blank" rel="noopener noreferrer">
                    <div className="service-item-catch"><p>買取価格５or１０％アップ</p></div>
                    <div className="service-item-img"><img src="/jinji_pic/netoff.png" alt="NET OFF(中古買取）概要" /></div>
                    <div className="service-item-title"><p>NET OFF(中古買取）</p></div>
                    <div className="service-item-detail"><p>WEBか電話でお申込ください。</p></div>
                  </a>
                  <a className="service-item" href="https://drive.google.com/file/d/1JJEk4HDGQxvfTKTQJycKHTiktpknuh2F/view?usp=drive_link" target="_blank" rel="noopener noreferrer">
                    <div className="service-item-catch"><p>会員種別の割引特典</p></div>
                    <div className="service-item-img"><img src="/jinji_pic/runesannsu.png" alt="NET OFF(中古買取）概要" /></div>
                    <div className="service-item-title"><p>ルネサンス（スポーツクラブ）</p></div>
                    <div className="service-item-detail"><p>事前に「健康保険委員登録証明書」を<br />印刷し、店舗に持参してください。</p><p>オンライン会員 クーポンコード「A1642mh2」</p></div>
                  </a>
                </div>
              </div>
            ) : (
              <></>
            )}

            {/* 子育て支援 */}
            {switchButtonTwoValue === "6" ? (
              <div className="contentFour">
                <h2 className="tag-title">子育て支援</h2>
                <h3 id="closedmart" className="icon-title type-pencil">ベビーシッター割引券配布</h3>
                <h4 className="bg-title mt-small">ベビーシッター割引券配布とは？</h4>


                <p>
                  乳幼児～小学校3年生の児童を育てているご家庭でご利用いただける「ベビーシッター割引券」（企業主導型内閣府ベビーシッター利用支援事業）を配布しております。本制度は、1回につき2枚（4,600円割引）使用でき、1家庭につき1か月最大24枚まで利用可能です。（1枚につき70円が課税対象となります）
                </p>

                <p>現在利用中の方はもちろん、初めての方もぜひご活用ください！<br />ご希望の方は人事部までご相談ください。</p>

                <h4 className="bg-title mt-small">利用方法</h4>
                <div className="numbering-wrap type-step">
                  <p>①ベビーシッター券の利用条件をご確認ください。<br />②各自でベビーシッター会社と契約します。（割引券を利用できるベビーシッター事業者であるかご確認ください。）<br />③人事部の割引券担当者までチャットでご連絡ください。利用手続きが完了次第、割引券URLをチャットにてお送りいたします。（必要枚数等はご相談ください。）<br />④ベビーシッターサービスを予約します。<br />⑤利用当日に、割引券URLより利用登録を行ってください。<br />⑥後日ベビーシッター会社より、割引後の代金が請求されます。
                  </p>
                </div>

                <h4 className="bg-title mt-small">注意点</h4>
                <p>・利用者本人と配偶者が仕事のために利用したベビーシッターサービスが割引対象です。<br />・乳幼児、または小学3年生までの児童を子育て中の社員が対象となります。<br />・対象児童1人につき1日（1回）の利用料金が2,300円（最大2枚まで）以上のベビーシッターサービスに割引券を使用できます。<br />・兄弟が対象児童であれば、人数分使えます。<br />（例）2人の場合は割引券を1回4枚使用可能＝9,200円割引！<br />・割引券1枚使用につき70円が給与課税の対象となります。<br />・利用日が未定の場合でも、割引券は申請いただけます。ただし、タイミングによってはすぐに割引券をお渡しできない場合もございますので、まずは担当者までお気軽にご相談ください。<br />・1家庭1か月24枚まで・年間280枚まで割引券をご利用いただけます。サービスご利用の際にはお気を付けください。<br />・割引券の有効期限は毎年3月末です。<br />・双子、または三つ子以上の義務教育就学前の多胎児を養育している家庭が対象となる「ベビーシッター派遣事業（多胎児分）」の割引券もございます。ご利用を検討される方は人事部までご相談ください。</p>
              </div>
            ) : (
              <></>
            )}

            {/* 財産形成-選択制DC */}
            {explanationChangeValue === "1" ? (
              <div className="contentOne-One">
                <h3 id="dc" className="icon-title type-pencil">選択制DC（企業型確定拠出年⾦）</h3>
                <h4 className="bg-title mt-small">選択制DC（企業型確定拠出年金）とは？</h4>
                <div className="d-flex flex-wrap-area justify-content-between">
                  <div className="flex-fill no-link-btn p-3">
                    月 50,000円まで拠出OK
                  </div>
                  <div className="flex-fill no-link-btn p-3">
                    税メリットあり
                  </div>
                  <div className="flex-fill no-link-btn p-3">
                    奨励金あり（最大4,000円）
                  </div>
                </div>

                <p className="">
                  選択制DC制度は任意加入となりますが、給与のうち5万円までの範囲でDC掛金に振り向けることで、税メリットを受けながら着実に老後の資産形成を行うことができるお得な制度です。
                </p>

                <h4 className="bg-title">【選択制DC】お手続きの流れ</h4>
                <div className="numbering-wrap type-step">
                  <h5 className="numbering-title">事務局からの案内後、説明会動画を視聴する</h5>
                  <p>約35分の動画となります。まずはどういった内容、メリットがあるかをご確認ください。</p>
                  <p>【DC事務局担当者】　井上（人事労務） ・ 佐々木（人事労務）</p>
                  <div className="iframe-wrapper my-4">
                    <iframe
                      width="560"
                      height="315"
                      src="https://www.youtube.com/embed/_ySIa5vvErU"
                      title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowfullscreen
                    ></iframe>
                  </div>

                  <h5 className="numbering-title">申込みフォームより、回答する</h5>
                  <p>
                    別途Googleフォームよりお申し込みいただきます。（時期になったら都度ご案内いたします）。<br />翌月初旬にユーザーIDがハガキで届きます。加入者向けサイトにログインできるかどうかご確認ください。
                  </p>

                  <h5 className="numbering-title">投資勉強会動画を視聴する</h5>
                  <p>約80分の動画となります。ご自身の資産形成に関することですので、是非とも真剣にご視聴ください。</p>
                  <div className="iframe-wrapper my-4">
                    <iframe
                      width="560"
                      height="315"
                      src="https://www.youtube.com/embed/P5vnH_yuqGw"
                      title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowfullscreen
                    ></iframe>
                  </div>

                  <h5 className="numbering-title">加入通知書兼運用指図書を提出する</h5>
                  <p>DC加入者向けサイトにログインし、投資商品一覧を確認の上、掛金割合等を記載し、人事事務課まで提出をお願いいたします。</p>

                  <h5 className="numbering-title">掛金が給与から拠出される</h5>
                  <p>3月のお申込みの場合、初回は4月給与から拠出額が天引きされ、5月分として拠出されます。以降毎月拠出額変更をするまでは同額での拠出となります。</p>

                  <h5 className="numbering-title">新規申込や拠出額変更は年2回</h5>
                  <p>申込、拠出額変更のタイミングは年2回。3月と9月に募集いたします。</p>

                  <h5 className="numbering-title">「確定拠出年金・残高のお知らせ」の電子版に登録する</h5>
                  <p>ご自身の資産に関わるお知らせが届きますので、個人のメールアドレスでご登録することをお勧めいたします。</p>

                  <p>【DC事務局担当者】　井上（人事労務） ・ 佐々木（人事労務）</p>
                </div>
              </div>
            ) : (
              <></>
            )}

            {/* 財産形成-持株会 */}
            {explanationChangeValue === "1" ? (
              <div className="contentOne-Two">
                <div className="h-presence-button with-heading">
                  <h3 id="stock" className="icon-title with-heading type-pencil">従業員持株会</h3>
                </div>
                <h4 className="bg-title mt-small">従業員持株会とは？</h4>
                <div className="d-flex flex-wrap-area justify-content-between">
                  <div className="flex-fill no-link-btn p-3">
                    月1,000円から投資可能
                  </div>
                  <div className="flex-fill no-link-btn p-3">
                    配当金も再投資
                  </div>
                  <div className="flex-fill no-link-btn p-3">
                    奨励金あり（一律5%）
                  </div>
                </div>
                <p>
                  従業員持株会制度は任意加入となりますが、給与のうち5万円までの範囲で自社株に投資をすることができます。
                  <br />また、投資額の5%の奨励金もありますので、そのまま投資額に上乗せすることもできます。
                </p>
                <p>
                  申込は年2回、『毎年2月および8月末日を締切日』とし、3月および9月の給与より拠出を開始します。
                </p>
                <div className="banner-area">
                  <a href="https://drive.google.com/file/d/1hWYZ6vexno1CaAn7dLEFQNyN9GrYES0p/view?usp=drive_link" target="blank">
                    <img
                      src={process.env.PUBLIC_URL + "/jinji_pic/mochikabu_banner.jpg"}
                      alt="持ち株会のバナー"
                      width={570}
                      height={143}
                    />
                  </a>
                </div>
                <h4 className="bg-title">【従業員持株会】　お手続きの流れ</h4>
                <div className="numbering-wrap type-step">
                  <h5 className="numbering-title">持株会新規募集動画を視聴する</h5>
                  <p>約2分の動画となります。まずはどのようなメリットがあるかをご確認ください。</p>
                  <div className="iframe-wrapper my-4">
                    <iframe
                      width="560"
                      height="315"
                      src="https://www.youtube.com/embed/9IyboaJsDrw"
                      title="YouTube video player"
                      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                      allowfullscreen
                    ></iframe>
                  </div>

                  <h5 className="numbering-title">説明会動画を視聴する</h5>
                  <p>約23分の動画となります。具体的な内容についてご確認ください。</p>
                  <div className="iframe-wrapper my-4">
                    <video
                      className="w-100 h-auto"
                      preload="none"
                      controls
                      loop
                      muted
                      poster={`${process.env.PUBLIC_URL}/jinji_pic/jinji_w01.jpg`}
                    >
                      <source
                        src={`${process.env.PUBLIC_URL}/jinji_mov/jinji_w01.mp4`}
                        type="video/mp4"
                      ></source>
                    </video>
                  </div>
                  <h5 className="numbering-title">申込みフォームより、エントリーする</h5>
                  <p>別途<a href="https://docs.google.com/forms/d/e/1FAIpQLSe5ggW__ustUGtGia9x-lVVVZumedEPbU_fmhharKQJokWp7A/viewform" target="_blank" className='text-link type-external'>Googleフォーム</a>よりお申し込みいただきます.事務局から「持株会届出書」をお渡しいたします。</p>

                  <h5 className="numbering-title">「持株会届出書」を持株会事務局に提出する</h5>
                  <p>必要事項の記入及び捺印後、持株会事務局担当者に届出書をご提出ください。2月申込みであれば3月給与から、8月申込みであれば9月給与から届出に基づき拠出されます。</p>

                  <p>
                    【事務局担当者】森下（経理部）・田代勇輔（人材戦略）
                  </p>

                </div>
              </div>
            ) : (
              <></>
            )}

            {/* 祝金制度-結婚・出産祝金 */}
            {explanationChangeValue === "3" ? (
              <div className="contentThree-One">
                <h3 id="marriage" className="icon-title type-pencil">結婚・出産祝金</h3>
                <h4 className="bg-title mt-small">結婚・出産祝金とは？</h4>

                <div className="d-flex flex-wrap-area justify-content-between">
                  <div className="flex-fill no-link-btn p-3">結婚で10万円</div>
                  <div className="flex-fill no-link-btn p-3">
                    出産で1人10万円
                  </div>
                  <div className="flex-fill no-link-btn p-3">
                    社員同士だと更に倍！！
                  </div>
                </div>
                <p>
                  おめでたいのに費用はかさむ、そんな皆さんに少しでも報いたい思いで、祝金額を増額いたしました！社員同士なら更におめでたいということで、お二人ともに祝金を贈呈いたします。
                </p>

                <h4 className="bg-title">【祝金申請】 お手続きの流れ</h4>
                <div className="numbering-wrap type-step">
                  <h5 className="numbering-title">以下の金額を確認し、「慶弔金支給申請書」を申請する</h5>
                  <p>申請方法は<a href="https://tvyj3455.talent-p.net/" target="_blank" className='text-link type-external'>タレントパレット</a>よりアクセスしてください。</p>
                  <p>
                    結婚祝金：10万円（※入籍のみも含みます）<br />
                    出産祝金：1人目10万円→2人目20万円→3人目以降都度30万円<br />
                    ※出産のみ、2022/4/1以降入社の社員は「入社後1年以上」という在籍条件が付きます。
                  </p>

                  <h5 className="numbering-title">承認後2週間以内に給与支給口座に振り込まれる</h5>
                  <p>
                    楽楽精算で申請書の承認後に、給与支給口座に振り込まれます。<br />
                    ※経費精算と同じタイミングでの処理となります。
                  </p>
                </div>
              </div>
            ) : (
              <></>
            )}

            {/* 祝金制度 */}
            {explanationChangeValue === "3" ? (
              <div className="contentThree-Two">
                <h3 id="paid" className="icon-title type-pencil">リファラル（社員紹介）制度</h3>
                <h4 className="bg-title mt-small">リファラル（社員紹介）制度とは？</h4>

                <p>
                  Zenken株式会社で働きたい！という方をご紹介いただき、その方がご入社された際に紹介者・被紹介者双方に紹介金をお渡しできる素晴らしい制度です。<br />※社会保険上は賞与扱いとなります<br />※支給のタイミングで両者とも在籍している事が条件となります<br />※沖縄オフィスは金額が異なります。<a href="https://drive.google.com/file/d/1zF4q_jCdpdtqb0wGFGfP7UI5hFwug9hS/view?usp=sharing" target="_blank" className='text-link type-external'>給与規程</a>をご確認ください。
                </p>

                <p>ーーーーーーーーー<br />正社員の場合<br />ご紹介いただくと、トータルで45万円が支給されます！<br />※3回に分けて支給されます</p>

                <p>①正社員登用の1か月後：15万円<br />②正社員登用の1年後　：15万円<br />③正社員登用の2年後　：15万円</p>

                <p>アルバイト・契約社員の場合<br />ご紹介いただくと、トータルで14万円が支給されます！<br />※2回に分けて支給されます<br />①契約社員（フルタイム）登用の1か月後：7万円<br />②契約社員（フルタイム）登用の1年後　：7万円<br />ーーーーーーーーー</p>

                <p>在籍社員の中にも、リファラル経由でZenken株式会社に興味をもっていただきご入社くださったメンバーが何人もいらっしゃいます！<br />一緒に働きたい、一緒にキャリアアップしていきたいと思える仲間がいらっしゃいましたらぜひ人事までお声がけください。</p>


                <h4 className="bg-title mt-small"> ご紹介窓口</h4>
                <p>人事部 人材戦略チーム 宮城・磯部までご連絡ください。</p>

                <p>・ご紹介いただく方の「お名前」「希望職種」「連絡先」をお伝えいただけますと、ご案内がスムーズです。<br />・Googleチャット、もしくは直接お声がけください。</p>

                <p>「ちょっと気になっている人がいるので面談してほしい」<br />「ぜひ入社してほしいので、社内見学に呼びたい」などなど、まずはご相談ベースでも構いません。
                  いままさにZenken株式会社で活躍している皆さまからのアツいご紹介をお待ちしております！
                </p>
              </div>
            ) : (
              <></>
            )}
            {/* メンタルヘルス、祝金制度の押下時の退避用 */}
            {explanationChangeValue === "6" ? <div className=""></div> : <></>}
          </div>
        </div >
      </div >
      <Footer />
    </>
  );
}
export default Welfare;
